import React, {Component} from 'react'
import fire from '../../../../database/firebase'
import styled from 'styled-components'

const Styles = styled.div `

`

export default class SignUpBusiness extends Component {
    constructor() {
        super()
        this.state = {

        }
    }

    login = () => {
        fire.auth().signInWithEmailAndPassword("normanburuchara90@gmail.com", "manzini2015")
        window.location.href = "/dashboard"
    }

    render () {
        return (
            <Styles>
                <div className='fullPage'>
                    <div className='navbar'>

                    </div>
                    <div className='content'>
                        <h1>Business Login</h1>
                        <button
                        onClick={this.login}
                        >Login</button>
                    </div>
                </div>
            </Styles>
        )
    }
}